import { render, staticRenderFns } from "./umatPerLingkungan.vue?vue&type=template&id=66cda60e&scoped=true&"
import script from "./umatPerLingkungan.vue?vue&type=script&lang=js&"
export * from "./umatPerLingkungan.vue?vue&type=script&lang=js&"
import style0 from "./umatPerLingkungan.vue?vue&type=style&index=0&id=66cda60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cda60e",
  null
  
)

export default component.exports